import { GetStaticPropsContext, InferGetStaticPropsType } from 'next';

import { FormDocument, FormQuery, FormQueryVariables } from '@/api';
import { addApolloState, initializeApollo } from '@/api/apolloClient';
import { LpHomePage } from '@/views/lpHome';
import { getLpHomeContent } from '@/views/lpHome/content';

export const getStaticProps = async (context: GetStaticPropsContext) => {
  const { locale } = context;
  const client = initializeApollo();

  // Section content is hardcoded for now (no Strapi). The contact form, however,
  // uses the existing CMS-backed <Form> component, so fetch its config here.
  const content = getLpHomeContent();

  const { data: formData } = await client.query<FormQuery, FormQueryVariables>({
    query: FormDocument,
    variables: { locale: locale || 'en' },
  });

  return addApolloState(client, {
    props: { content, formData },
  });
};

const Home = ({
  content,
  formData,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  return <LpHomePage content={content} formData={formData} />;
};

export default Home;
